<template>
  <net-popup-menu v-if="ctx.chart">
    <template #title>{{ $t("objectNames.chart") }}</template>

    <div class="column">
      <chart-type-chooser
        :chart-type="ctx.chart.chartType"
        @update:chartType="store.setChartType(ctx.chart.id, $event)"
      />
      <chart-axes-settings
        v-if="ctx.chart.chartType"
        :chart-type="ctx.chart.chartType"
        :axes="ctx.chart.chartSettings"
        @update:x-axis="store.setAxis(ctx.chart.id, 'x', $event)"
        @update:y-axis="store.setAxis(ctx.chart.id, 'y', $event)"
      />
    </div>

    <div>
      <h3 class="label mb-0">{{ $t('objectNames.simulation', chartAxisConfig?.singleSimulation ? 1 : 10) }}</h3>
      <chart-builder-simulations :chart-uid="ctx.chart.uid" />
    </div>

    <div>
      <h3 class="label mb-2">{{ $t('labels.data') }}</h3>

      <chart-builder-item-single
        v-if="chartAxisConfig?.singleItem"
        :chart-uid="ctx.chart.uid"
        :item-options="itemOptions"
        :selected-item="selectedItem"
        @selectItem="selectItem"
      />
      <chart-builder-items v-else :chart-uid="ctx.chart.uid" />
    </div>

    <div>
      <h3 class="label">{{ $t('labels.design') }}</h3>
      <chart-settings-list
        :chart="ctx.chart"
        :settings="settings"
        :remove-settings="['width', 'height']"
        @update="updateChartSettings($event)"
      ></chart-settings-list>
    </div>

    <!-- DELETE -->
    <button
      type="button"
      class="button button_secondary mv-2"
      @click="ctx.delete()"
    >
      {{ $t("actions.deleteChart", 1) }}
    </button>
  </net-popup-menu>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import NetPopupMenu from '@editor/net/NetPopupMenu.vue';

import ChartAxesSettings from '../charts/ChartAxesSettings.vue';
import ChartTypeChooser from '../charts/ChartTypeChooser.vue';
import ChartBuilderSimulations from '../charts/ChartBuilderSimulations.vue';
import ChartSettingsList from '../charts/ChartSettingsList.vue';
import ChartBuilderItemSingle from '../charts/ChartBuilderItemSingle.vue';
import ChartBuilderItems from '../charts/ChartBuilderItems.vue';

import { useSceneChart } from './useSceneChart';
import { useChartData } from '../charts/useChartData';
import { useChartStore } from '../charts/charts.store';
import type { ChartSettings, SelectableChartItem } from '../charts/ChartItem';
import type { Uid } from '@/helpers/utility/Id';

const props = defineProps<{
  chartId: number;
  nodeUid: Uid<"sceneNode">;
}>();

const ctx = useSceneChart(() => props.nodeUid);
const store = useChartStore();

const { chartAxisConfig, itemOptions, selectedItem } = useChartData(() => ctx.chart);

const settings = computed(() => ({
  ...ctx.chart?.chartSettings
}));

function selectItem(item: SelectableChartItem | null) {
  if (!ctx.chart) return;
  store.selectItem(ctx.chart.id, item);
}

function updateChartSettings(settings: Partial<ChartSettings>) {
  if (!ctx.chart) return;
  return store.updateChartSettings(ctx.chart.id, settings);
}
</script>